module.exports = __webpack_public_path__ + "static/media/logo.af536509.png";